import { api, defaultQueriesFor } from '../apiSlice';

export const truckApi = api
  .enhanceEndpoints({ addTagTypes: ['Truck'] })
  .injectEndpoints({
    endpoints: build => ({
      ...defaultQueriesFor(build, 'Truck', 'Trucks', true),

      getTruckWithParams: build.query({
        query: ({ id, ...params }) => {
          const queryString = new URLSearchParams(params).toString();
          return `/trucks/${id}${queryString ? `?${queryString}` : ''}`;
        },
        providesTags: ['Truck']
      }),

      updateCreditCard: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/update_credit_card`,
          method: 'POST',
          body: { truck: params.truck }
        }),
        invalidatesTags: ['Truck']
      }),

      updatePhotos: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/update_photos`,
          method: 'POST',
          body: {
            truck: { photos: params.photos },
            delete_new_photo: params.delete_new_photo
          }
        }),
        invalidatesTags: ['Truck']
      }),

      deletePhoto: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/delete_photo`,
          method: 'DELETE',
          body: params
        }),
        invalidatesTags: ['Truck']
      }),

      updateMenu: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/update_menu`,
          method: 'POST',
          body: { truck: { menu: params.menu } }
        }),
        invalidatesTags: ['Truck']
      }),

      syncGoogleCalendar: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/sync_calendar`,
          method: 'GET'
        }),
        invalidatesTags: ['Truck']
      }),

      getGoogleCalendarDetails: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/calendar_details`,
          method: 'GET'
        }),
        invalidatesTags: ['Truck']
      }),

      subscribe: build.mutation({
        query: (params) => ({
          url: `/trucks/${params.truckId}/subscribe`,
          method: 'POST',
          body: { plan_id: params.planId }
        }),
        invalidatesTags: ['Truck']
      }),

      fetchDeletionStatus: build.query({
        query: (params) => `/trucks/deletion_status?id=${params.id}`,
        providesTags: ['Truck']
      }),

    }),
  });

export const {
  useCreateTruckMutation,
  useDeleteTruckMutation,
  useDeletePhotoMutation,
  useGetTruckByIdQuery,
  useGetTrucksQuery,
  useGetTruckWithParamsQuery,
  useUpdateCreditCardMutation,
  useUpdateMenuMutation,
  useUpdatePhotosMutation,
  useUpdateTruckMutation,
  useSyncGoogleCalendarMutation,
  useGetGoogleCalendarDetailsMutation,
  useSubscribeMutation,
  useFetchDeletionStatusQuery,
} = truckApi;
